export default function fillCities() {
  var city = '[name="city"]';
  let cityText = $(city).html();
  const disabled = 'disabled';
  const form = 'form';
  $('[name="state"]').change(function (event) {
    var sel = $(this);

    if (!(sel.closest(form).hasClass('formRepresentative'))) {

      if (sel.val().length > 0) {
        $.ajax({
          url: sel.attr('data-ajax'),
          type: 'POST',
          dataType: 'html',
          data: {
            state: sel.val(),
            '_token': $('meta[name="csrf-token"]').attr('content')
          },
          error: function () {
            sel.closest(form).find(city).html(cityText).attr(disabled, disabled);
            console.error('get cities error');
          },
          success: function (html) {
            sel.closest(form).find(city).html(html).removeAttr(disabled);
            if (sel.closest(form).hasClass('formBag')) {
              $.each(sel.closest(form).find(city).find('option'), (index, val) => $(val).val($(val).text()));
            }
          }
        });
      } else {
        sel.closest(form).find(city).html(cityText).attr(disabled, disabled);
      }
    }
  });
}